$ = require 'jquery'
Auth = require 'db/auth'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
View = require 'view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
PowerUpItemDetailsView = require 'views/board-menu/power-up-item-details-view'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
templates = require 'views/internal/templates'
powerUpItemTemplate = require 'views/templates/power_up_item'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
_ = require 'underscore'
ClientConfig = require 'debug/client-config'

module.exports = class BoardPowerUpItemView extends View

  initialize: ({ @powerUp }) ->
    @listenTo @model, 'change:powerUps', @frameDebounce @renderEnabledState
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @renderEnabledState
    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @frameDebounce @renderEnabledState

    @subscribe pluginsChangedSignal(@model), => @renderEnabledState()
    return

  className: 'power-up-item'

  events:
    'click .js-enable': (e) ->
      Util.stop(e)
      PopOver.hide()
      @enable()

    'click .js-disable': (e) ->
      Util.stop(e)
      PopOver.hide()
      @disable(e.currentTarget)

    'click .js-show-details': (e) ->
      Util.stop(e)
      @showDetails(e.currentTarget)

    'click .js-show-settings': (e) ->
      Util.stop(e)
      @showSettings(e.currentTarget)

  vigor: @VIGOR.NONE
  renderOnce: ->
    if !@options.disableOnly?
      if @model.hasOrganization()
        upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)

    @$el.html(
      powerUpItemTemplate({
        iconSrc: @powerUp.iconSrc,
        canEnable: @model.editable,
        upgradeUrl,
        displayName: @powerUp.displayName,
        upsellEnabled: !ClientConfig.get('dontUpsell')
        details: templates.fill(@powerUp.aboutTemplate)
      })
    )

    @renderEnabledState()

    @

  getEnabledState: ->
    @model.isPowerUpEnabled(@powerUp.name)

  renderEnabledState: ->
    isEnabled = @getEnabledState()
    disableOnly = @options.disableOnly
    canEnableAdditional = @model.canEnableAdditionalPowerUps()
    hasDismissedAd = Auth.me().isDismissed("PowerUpsLimitFullAd")

    @$el.toggleClass('is-enabled', isEnabled)
    @$el.toggleClass('needs-upgrade', !isEnabled && !canEnableAdditional && hasDismissedAd)
    @$el.toggleClass('fake-enable', !isEnabled && !canEnableAdditional && !hasDismissedAd)
    @

  enable: ->
    @model.enablePlugin(@powerUp.idPlugin)
    track('Power-Ups', @powerUp.name, 'Enable')
    trackUe('Power-Up listing', 'enables', 'Power-Up', '', '', 'enable button', @powerUp.idPlugin)
    return

  isGrandfathered: ->
    @powerUp.name in @model.get('powerUps')

  disable: (elem) ->
    if @isGrandfathered()
      removePowerUp = =>
        @model.pull('powerUps', @powerUp.name)
        track('Power-Ups', @powerUp.name, 'Disable')
        trackUe('Power-Up listing', 'disables', 'Power-Up', '', '', 'disable button', @powerUp.idPlugin)

      if @model.getOrganization()?.isFeatureEnabled('plugins')
        removePowerUp()
      else
        Confirm.toggle 'disable power up',
          elem: elem
          model: @model
          confirmBtnClass: 'negate'
          fxConfirm: removePowerUp
    else
      @model.disablePlugin(@powerUp.idPlugin)
      track('Power-Ups', @powerUp.name, 'Disable')
      trackUe('Power-Up listing', 'disables', 'Power-Up', '', '', 'disable button', @powerUp.idPlugin)
    return

  showDetails: (elem) ->
    PopOver.toggle
      elem: elem
      view: new PowerUpItemDetailsView({
        @powerUp,
        isGrandfathered: @isGrandfathered()
      })
      autoPosition: true

    track('Power-Ups', @powerUp.name, 'Show Details')
    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'show-details', @powerUp.idPlugin)

  showSettings: (elem) ->
    PopOver.toggle
      elem: elem
      view: @powerUp.settingsView(@model, @isGrandfathered())
      autoPosition: true

    track('Power-Ups', @powerUp.name, 'Show Details')
    trackUe('Power-Up listing', 'opens', 'Power-Up', '', '', 'edit-settings', @powerUp.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-power-up-item-view.coffee